import React from 'react';
import './SplashPage.css'

import Home from '../containers/home';
import Portfolio from '../containers/portfolio';

const WebPage = () => (
  <div className="Web">
    <Home />
    <Portfolio />
  </div>
)

export default WebPage